(function () {

  const htmlElements = document.querySelectorAll('.js_wl_product_group');

  function init() {
    for (let i = 0; i < htmlElements.length; i++) {
      const htmlElement = htmlElements[i];

      handleEqualHeightOnContentElements(htmlElement);

      window.addEventListener("resize", (event) => {
        handleEqualHeightOnContentElements(htmlElement);
      });
    }
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(init);
  } else {
    window.addEventListener('load', init, { once: true });
  }

  function handleEqualHeightOnContentElements(htmlElement) {
    const _contents = htmlElement.querySelectorAll('.wl-product__card-footer');
    if (window.innerWidth > 766) {
      setEqualHeightOnContentElements(_contents);
    }
    else {
      _contents.forEach((content) => {
        content.children[0].style.height = 'initial';
        content.children[1].style.height = 'initial';
      });
    }
  }

  function setEqualHeightOnContentElements(contents) {
    if (contents) {

      let _titleMaxHeight = 0;
      let _textMaxHeight = 0;

      contents.forEach((content) => {
        _titleMaxHeight = getElementMaxHeight(content.children[0].children[0], _titleMaxHeight);
        _textMaxHeight = getElementMaxHeight(content.children[1].children[0], _textMaxHeight);
      });

      contents.forEach((content) => {
        content.children[0].style.height = _titleMaxHeight + 'px';
        content.children[1].style.height = _textMaxHeight + 'px';
      });

    }
  }

  function getElementMaxHeight(el, elMaxHeight) {
    if (el.clientHeight > elMaxHeight) {
      elMaxHeight = el.clientHeight;
    }

    return elMaxHeight;
  }

})()
